import { memo, useContext, useState } from "react";
import { Tooltip } from "../../../tooltip/tooltip";
import { AvatarStatus, RedoAvatar } from "../../avatar/redo-avatar";
import * as navigationCss from "../redo-navigation.module.css";
import { TeamDataContext } from "./team-switcher-data";
import { TeamSwitcherDropdown } from "./team-switcher-dropdown";

export const RedoNavigationTeamItem = memo(function RedoNavigationTeamItem() {
  const teamData = useContext(TeamDataContext);

  const [dropdownAnchor, setDropdownAnchor] = useState<HTMLElement | null>(
    null,
  );
  const [switcherDropdownOpen, setSwitcherDropdownOpen] = useState(false);

  if (!teamData) {
    return null;
  }

  const { currentTeam } = teamData;

  const status: AvatarStatus | undefined = teamData.connectedStoresHaveTickets
    ? { type: "presence", color: "red" }
    : undefined;

  return (
    <>
      <Tooltip darkMode placement="right" title={currentTeam.name}>
        <button
          className={navigationCss.teamItem}
          data-arbiter="RedoNavigationTeamItem"
          onClick={() => setSwitcherDropdownOpen((old) => !old)}
          ref={setDropdownAnchor}
        >
          <RedoAvatar
            content={{
              type: "image",
              imageUrl: currentTeam.logoUrl,
              altText: currentTeam.name,
              backup: { type: "text", text: currentTeam.name },
            }}
            size="sm"
            status={status}
          />
        </button>
      </Tooltip>
      <TeamSwitcherDropdown
        dropdownAnchor={dropdownAnchor}
        dropdownOpen={switcherDropdownOpen}
        setDropdownOpen={setSwitcherDropdownOpen}
        teamData={teamData}
      />
    </>
  );
});
